import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Formik } from 'formik';
import * as yup from 'yup';

import AppBar from 'components/AppBar';
//import SubmitButton from 'components/Buttons/SubmitButton';
import Field from 'components/Field';
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import Loader from 'components/Loader';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { BillingCompany } from 'models/billingCompany';
//import { NationalityCountry } from 'models/country';
import ResponseScreen, { BackgroundTypes } from 'screens/components/ResponseScreen';
import { extractErrorMessage } from 'utils/generic';
import { RenderProps as BookingSelectRenderProps } from 'components/Selects/BookingSelectDate';

import { Container, Form, Fields } from './styles';
import useUserAccount from 'hooks/useUserAccount';
import ToggleCard from 'components/ToggleCard';
import { ThemeProvider } from 'styled-components';
import CitiesAutoCompleteSelect from 'components/Selects/CitiesAutoCompleteSelect';
import { customTheme } from 'components/DesktopFlightsSearch/customTheme';
import { CityAutoComplete } from 'models/cityAutoComplete';
import AutoCompleteCitiesSearchContainer from 'containers/AutoCompleteCities';
import CountriesAutoCompleteSelect from 'components/Selects/CountriesAutoCompleteSelect';
import AutoCompleteCountriesSearchContainer from 'containers/AutoCompleteCountries';
import { CountryAutoComplete } from 'models/countryAutoComplete';
import SubmitButton from 'components/Buttons/SubmitButton';
import { ProvinceAutoComplete } from 'models/provinceAutoComplete';
import ProvincesAutoCompleteSelect, { RenderProps } from 'components/Selects/ProvincesAutoCompleteSelect';
import AutoCompleteProvincesSearchContainer from 'containers/AutoCompleteProvinces';

interface Props {
  loading: boolean;
  submitting: boolean;
  billingCompany?: BillingCompany;
  //countryCurrency: string;
  isFromSelection?: boolean;
  onConfirm: (billingCompany: BillingCompany) => Promise<void>;
  onCloseFormCostCenter?: () => void;
  //fetchCountryList: () => Promise<void>;
  //nationalityCountries: NationalityCountry[];
  //loadingNationalityCountries: boolean;
}

const BillingCompanyForm = ({
  loading,
  submitting,
  billingCompany,
  //countryCurrency,
  onConfirm,
  isFromSelection,
  onCloseFormCostCenter,
  //fetchCountryList,
  //nationalityCountries,
  //loadingNationalityCountries,
}: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();
  const toast = useToast();
  const [showSuccess, setShowSuccess] = useState(false);
  const user = useUserAccount();
  const isEdit = !!billingCompany && billingCompany.companyId !== '';
  const [cityCode, setCityCode] = useState<CityAutoComplete | undefined>();
  const [provinceCode, setProvinceCode] = useState<ProvinceAutoComplete | undefined>();
  const [countryCode, setCountryCode] = useState<CountryAutoComplete | undefined>();

  const validationSchema = yup.object().shape({
    legalName: yup.string().trim().required(),
    corporateName: yup.string().trim().required(),
    document: yup.string().required(),
    email: yup.string().email().required(),
    contactName: yup.string().required(),
    contactLastName: yup.string().required(),
    contactEmail: yup.string().email().required(),
    contactPhoneNumber: yup.string().phone().required(),
    billingCompanyAddress: yup.string().required(),
    billingCompanyAddressNumber: yup.string().required(),
    billingCompanyAddressPostalCode: yup.string().required(),
  });

  const initialValues: BillingCompany = {
    companyId: billingCompany?.companyId || undefined,
    legalName: billingCompany?.legalName || '',
    corporateName: billingCompany?.corporateName || '',
    document: billingCompany?.document || '',
    email: billingCompany?.email || '',
    countryId: billingCompany?.countryId || '',
    onboardingDone: billingCompany?.onboardingDone || '',
    bookingAllowed: billingCompany?.bookingAllowed || '',
    optimisticPayments: billingCompany?.optimisticPayments || '',
    lineOfCreditAvailable: billingCompany?.lineOfCreditAvailable || false,
    companyCreditCardByUser: billingCompany?.companyCreditCardByUser || false,
    contactName: billingCompany?.contactName || '',
    contactLastName: billingCompany?.contactLastName || '',
    contactPhoneNumber: billingCompany?.contactPhoneNumber || '',
    contactEmail: billingCompany?.contactEmail || '',
    contactDocumentNumber: billingCompany?.contactDocumentNumber || '',
    contactBillingEmail: billingCompany?.contactBillingEmail || '',
    billingCompanyAddress: billingCompany?.billingCompanyAddress || '',
    billingCompanyAddressNumber: billingCompany?.billingCompanyAddressNumber || '',
    billingCompanyAddressCity: cityCode?.cityCode || '',
    billingCompanyAddressProvince: provinceCode?.provinceCode || '',
    billingCompanyAddressCountry: countryCode?.countryCode || '',
    billingCompanyAddressPostalCode: billingCompany?.billingCompanyAddressPostalCode || '',
  };

  const handleConfirm = async (values: typeof initialValues, setSubmitting: (isSubmitting: boolean) => void) => {

    try {
       debugger;   
      values.billingCompanyAddressCity = cityCode?.cityCode || '';
      values.billingCompanyAddressProvince = provinceCode?.provinceCode || '';
      values.billingCompanyAddressCountry = countryCode?.countryCode || '';

      if (countryCode?.countryCode !== cityCode?.countryCode) {
        toast.add({
          type: 'danger',
          message: t('branchCompany.errors.countryCityError'),
        });
        setSubmitting(false);
        return;
      }

      if (values.billingCompanyAddressCountry === '' || values.billingCompanyAddressCity === ''  || values.billingCompanyAddressProvince === '') {

          toast.add({
            type: 'danger',
            message: t('branchCompany.errors.countryCity'),
          });
          setSubmitting(false);
          return;          
      }

      await onConfirm({
        ...billingCompany,
        ...values,
      } as BillingCompany);
      if (!isFromSelection) setShowSuccess(true);
    } catch (error) {
      if (error.message) {
        if (error?.message?.includes('already') !== -1) {
          toast.add({
            type: 'danger',
            message: t('branchCompany.errors.alreadyExists'),
          });
        }
      } else {
        //alert(error.message);
        toast.add({
          type: 'danger',
          message: extractErrorMessage(error) || t('defaultError.default'),
        });
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleNavigateHistory = () => {
    if (isFromSelection) {
      if (onCloseFormCostCenter) onCloseFormCostCenter();
    } else {
      history.push('/corporate/billingCompanyList');
    }
  };

  const getCitySelectValue = (city: CityAutoComplete | undefined) => {
    if (!city) return;

    return {
      name: city.cityName,
      detail: `${city.cityCode}, ${city.cityName}`,
    };
  };

  const getCountrySelectValue = (country: CountryAutoComplete | undefined) => {
    if (!country) return;

    return {
      name: country.countryName,
      detail: `${country.countryCode}, ${country.countryName}`,
    };
  };

  const getProvinceSelectValue = (province: ProvinceAutoComplete | undefined) => {
    if (!province) return;

    return {
      name: province.name,
      detail: `${province.provinceCode}`,
    };
  };

  const renderCountrySelect = () => (
    <ThemeProvider theme={customTheme}>
      <CountriesAutoCompleteSelect
        label={t('branchCompany.form.address.countryTitle')}
        detail={t('branchCompany.form.address.countryPlaceHolder')}
        value={getCountrySelectValue(countryCode)}
        onChange={(value, isCountry?: boolean) => {
          setCountryCode(value as CountryAutoComplete);
          setCityCode(undefined);
        }}
        testId="country-location"
      >
        {(selectProps: BookingSelectRenderProps) => (
          <AutoCompleteCountriesSearchContainer
            {...selectProps}
            placeHolder={t('branchCompany.form.address.countryModal')}
          />
        )}
      </CountriesAutoCompleteSelect>
    </ThemeProvider>
  );

  const renderProvinceSelect = () => (
    <ThemeProvider theme={customTheme}>
      <ProvincesAutoCompleteSelect
        label={t('branchCompany.form.address.provinceTitle')}
        detail={t('branchCompany.form.address.provincePlaceHolder')}
        value={getProvinceSelectValue(provinceCode)}
        onChange={(value, isCountry?: boolean) => {
          setProvinceCode(value as ProvinceAutoComplete);
          setCityCode(undefined);
        }}
        testId="province-location"
      >
        {(selectProps: RenderProps) => (
          <AutoCompleteProvincesSearchContainer
            {...selectProps}
            countryCode={countryCode?.countryCode}
            placeHolder={t('branchCompany.form.address.provinceModal')}
          />
        )}
      </ProvincesAutoCompleteSelect>
    </ThemeProvider>
  );
    
  const renderCitySelect = () => (
      <ThemeProvider theme={customTheme}>
        <CitiesAutoCompleteSelect
          label={t('branchCompany.form.address.cityTitle')}
          detail={t('branchCompany.form.address.cityPlaceHolder')}
          value={getCitySelectValue(cityCode)}
          onChange={(value, isCity?: boolean) => {
            setCityCode(value as CityAutoComplete);
          }}
          testId="city-location"
        >
          {(selectProps: BookingSelectRenderProps) => (
            <AutoCompleteCitiesSearchContainer
              country={countryCode?.countryCode}
              {...selectProps}
              placeHolder={t('branchCompany.form.address.cityModal')}
            />
          )}
        </CitiesAutoCompleteSelect>
      </ThemeProvider>
  );

  /*useEffect(() => {
    if (!nationalityCountries.length && !loadingNationalityCountries) {
      fetchCountryList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchCountryList, nationalityCountries]);*/

  return (
    <Container>
      <Mobile>
        <AppBar goBack={handleNavigateHistory}>
          <h5>{t('branchCompany.form.title', { resellerName: user.companyName })}</h5>
        </AppBar>
      </Mobile>
      {loading ? (
        <Loader fullScreen />
      ) : (
        <>
          <Desktop>
            <ScreenHeader
              title={t('branchCompany.form.title', { resellerName: user.companyName })}
              subtitle={t('branchCompany.form.subtitle')}
            />
          </Desktop>

          <Formik
            initialValues={initialValues as BillingCompany}
            validationSchema={validationSchema}
            validateOnChange={false} 
            onSubmit={(values: BillingCompany, { setSubmitting }) => {
              
              if (!cityCode || !countryCode) {
                toast.add({
                  type: 'danger',
                  message: t('branchCompany.errors.countryCity'),
                });
                setSubmitting(false);
                return;
              }
          
              handleConfirm(values, setSubmitting); 
            }}
          >
            {({ values, dirty, isSubmitting, setFieldValue, handleSubmit }) => (
              <>
                <FormikSubmitErrorEffect />

                {/* Garantir que a validação só ocorra ao enviar */}
                <Form isEdition={isEdit && dirty} onSubmit={handleSubmit}>
                  <Fields>
                    <Section title={t('branchCompany.form.company.title')}>
                      <Field name="corporateName" label={t('branchCompany.form.company.corporateNameLabel')}>
                        <Input placeholder={t('branchCompany.form.company.corporateNamePlaceholder')} />
                      </Field>
                      <Field name="legalName" label={t('branchCompany.form.company.legalNameLabel')}>
                        <Input placeholder={t('branchCompany.form.company.legalNamePlaceholder')} />
                      </Field>
                      <Field name="document" label={t('branchCompany.form.company.documentLabel')}>
                        <Input 
                          placeholder={t('branchCompany.form.company.documentPlaceholder')}
                          onChange={(e) => {
                            e.currentTarget.value = e.currentTarget.value.replace(/\s/g, '');
                          }} />
                      </Field>
                      <Field name="email" label={t('branchCompany.form.company.emailLabel')}>
                        <Input placeholder={t('branchCompany.form.company.emailPlaceholder')} />
                      </Field>
                    </Section>
                    <Section title={t('branchCompany.form.contact.title')}>
                      <Field name="contactName" label={t('branchCompany.form.contact.contactNameLabel')}>
                        <Input placeholder={t('branchCompany.form.contact.contactNamePlaceholder')} />
                      </Field>
                      <Field name="contactLastName" label={t('branchCompany.form.contact.contactLastNameLabel')}>
                        <Input placeholder={t('branchCompany.form.contact.contactLastNamePlaceholder')} />
                      </Field>
                      <Field name="contactEmail" label={t('branchCompany.form.contact.contactEmailLabel')}>
                        <Input placeholder={t('branchCompany.form.contact.contactEmailPlaceholder')} />
                      </Field>
                      <Field name="contactPhoneNumber" label={t('branchCompany.form.contact.contactPhoneNumberLabel')}>
                        <Input placeholder={t('branchCompany.form.contact.contactPhoneNumberPlaceholder')} />
                      </Field>
                    </Section>
                    <Section title={t('branchCompany.form.address.title')}>
                      <Field name="billingCompanyAddress" label={t('branchCompany.form.address.addressStreetLabel')}>
                        <Input placeholder={t('branchCompany.form.address.addressStreetPlaceholder')} />
                      </Field>
                      <Field name="billingCompanyAddressNumber" label={t('branchCompany.form.address.addressStreetNumberLabel')}>
                        <Input placeholder={t('branchCompany.form.address.addressStreetNumberPlaceholder')} />
                      </Field>
                      
                      {renderCountrySelect()}
                      {renderProvinceSelect()}
                      {renderCitySelect()}
                      
                      <Field name="billingCompanyAddressPostalCode" label={''}>
                        <Input placeholder={t('branchCompany.form.address.addressPostalCodePlaceholder')} />
                      </Field>
                    </Section>
                    <Section title={t('branchCompany.form.payment.title')}>
                      <ToggleCard
                        title={t('branchCompany.form.payment.lineOfCredit')}
                        value={values.lineOfCreditAvailable}
                        onToggle={(_, value) => setFieldValue('lineOfCreditAvailable', value ? true : false)}
                        hide={false}
                      />
                      <ToggleCard
                        title={t('branchCompany.form.payment.creditCard')}
                        value={!values.lineOfCreditAvailable}
                        onToggle={(_, value) => setFieldValue('lineOfCreditAvailable', value ? false : true)}
                        hide={false}
                      />
                      <ToggleCard
                        title={t('branchCompany.form.payment.creditCardByCompany')}
                        value={!values.companyCreditCardByUser}
                        onToggle={(_, value) => setFieldValue('companyCreditCardByUser', value ? false : true)}
                        hide={values.lineOfCreditAvailable}
                      />
                      <ToggleCard
                        title={t('branchCompany.form.payment.creditCardByUser')}
                        value={values.companyCreditCardByUser}
                        onToggle={(_, value) => setFieldValue('companyCreditCardByUser', value ? true : false)}
                        hide={values.lineOfCreditAvailable}
                      />
                    </Section>
                  </Fields>
                  
                  <SubmitButton isEdit={isEdit} dirty={dirty} loading={submitting || isSubmitting}>
                    {t(isEdit ? 'branchCompany.buttons.edit' : 'branchCompany.buttons.confirm')}
                  </SubmitButton>
                </Form>
              </>
            )}
          </Formik>


          <ResponseScreen
            show={showSuccess}
            background={BackgroundTypes.Mountain}
            text={t('branchCompany.form.successTitle')}
            subText={
              !!billingCompany?.companyId
                ? t('branchCompany.form.successEditText')
                : t('branchCompany.form.successConfirmText')
            }
            buttonOnClick={() => history.push('/corporate/billingCompanyList')}
            buttonText={t('branchCompany.form.successButtonText')}
          />
        </>
      )}
    </Container>
  );
};

export default BillingCompanyForm;
